import { ADD_PACKAGE_ROLE, DELETE_PACKAGE_ROLE, GET_PACKAGE_ROLES, UPDATE_PACKAGE_ROLE, UPDATE_PACKAGE_ROLE_STATUS } from "../types";


const initialState = {list: [], single: null, cities: []};

const reducer = (state = initialState, action) => {
    const {type, payload} = action;

    switch (type) {
        case GET_PACKAGE_ROLES:
            return {...state, list: payload};

        case UPDATE_PACKAGE_ROLE:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload.id ? payload : item
                ),
            };
            
        case UPDATE_PACKAGE_ROLE_STATUS:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload.id ? payload : item
                ),
            };

        case ADD_PACKAGE_ROLE:
            return {
                ...state,
                list: [payload, ...state.list],
            };

        case DELETE_PACKAGE_ROLE:
            return {
                ...state,
                list: state.list.filter((item) => item.id !== payload.id),
            };

        default:
            return state;
    }
};

export default reducer;
